import { css } from 'lit';
import { fsDesignToken } from '../../core/services/utils/style.utils.js';

export const style = css`
  /** Loan FLow */
  .offers-list {
    margin: 0 1em 2em;
  }

  @media (min-width: 48em) {
    .offers-list {
      margin: 0 auto 2em;
      width: 80%;
    }
  }

  .end-message {
    text-align: center;
    white-space: pre-wrap;
  }

  .select-offer-btn {
    display: block;
    margin: 0 auto;
  }

  .modal-content {
    text-align: center;
  }

  .modal-content > h2 {
    margin-top: 0;
  }

  .exit-page-link {
    display: block;
    margin: 24px auto;
    text-align: center;
  }

  /** Compare Old Loan */
  .offers-list-compare-old-loan .header-section {
    background: ${fsDesignToken('fsColorCoreBlue60')};
    font-weight: 300;
    margin: 0 auto;
    overflow-x: clip;
    padding: 0 24px ${fsDesignToken('fsSizeSpacingMedium2')} 24px;
    position: relative;
    text-align: left;
  }

  @media (min-width: 320px) and (max-width: 374px) {
    .header-section {
      padding-bottom: ${fsDesignToken('fsSizeSpacingMedium2')};
    }

    p {
      width: 272px;
    }
  }

  @media (min-width: 48em) {
    .offers-list-compare-old-loan {
      margin: 0 auto 2em;
      width: 100%;
    }
  }

  .header-and-body {
    margin: 0 auto;
    overflow-x: clip;
    position: relative;
  }

  .grv-color--white {
    color: ${fsDesignToken('fsColorConstantWhite')};
  }

  .header-content {
    margin: 0 auto;
    max-width: 30em;
    overflow-x: clip;
    position: relative;
  }

  @media (min-width: 48em) {
    .header-and-body {
      overflow: visible;
    }
  }

  .offers-list-compare-old-loan .footer-section .date-valid-through {
    font-size: 14px;
    margin: 16px 5em;
    text-align: center;
  }

  .offers-list-compare-old-loan .monthly-payment-disclaimer {
    bottom: -3em;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
  }

  .offers-list-compare-old-loan .monthly-payment-disclaimer .disclaimer-text {
    color: #696969;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin: 0 18px 18px;
    max-width: 460px;
  }

  .original-loan {
    margin: 0 auto;
    max-width: 30em;
    padding: 8px 24px 8px 24px;
    text-align: left;
  }

  .original-loan .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
    padding-bottom: 12px;
  }

  .original-loan-section {
    background: ${fsDesignToken('fsColorInteractionBlue5')};
    overflow-x: clip;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 1;
  }

  .is-unstuck {
    box-shadow: 0 2px 8px 0 #0003;
  }

  @media screen and (min-width: 373px) {
    .is-unstuck > .original-loan {
      max-width: 28em;
      padding: 8px 41px 12px 41px;
    }
  }

  .default-disclosure {
    display: inline-grid;
    justify-content: center;
    position: relative;
    width: 100%;
  }

  .disclosure-text {
    color: #696969;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 18px;
    margin: 0 18px 18px;
    max-width: 460px;
    text-align: left;
  }

  .disclosure-text sup {
    font-size: 0.5em;
  }

  .cards-section {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 30em;
    overflow-x: clip;
    padding: 16px 24px 24px 24px;
    position: relative;
    row-gap: 16px;
  }

  .valid-through-date {
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    margin: 0 24px 24px;
    text-align: left;
  }
`;
